import Select from "../../../common/select";
import PumpPerformanceChart from "../../../line-graphs";
import SwitchButton from "../../../common/switch-button";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import { typeOfShaft } from "../../../../constants/dropdown/calculations";
import { useGasHandlerFacade } from "../../../../facade/calculation/calculation-output/gas-handler.facade";
import { useGasCalculationFacade } from "../../../../facade/calculation/calculation-output/gasCalculation.facade";
import EquipmentTableAddChargePump from "../../../common/equipment-table-charge-pump";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import Accordion from "../../../common/accordion";
import { useEffect } from "react";
import { LABELS } from "../../../../constants/labels/gasCals.labels";
import useCalculationFacade from "../../../../facade/calculation/calculation.facade";
import Dropdown from "../../../common/dropdown";

const GasHandler = () => {

    const { showGkxGraphControl, GKXCalculationData } = useAppSelector((state) => state?.gasHandler);
    const { gasHandlerCollapse } = useAppSelector((state) => state?.collapse);
    const {
        BasicGasCalculation,
        GasCalculationOutPut,
        gkxPumpCapacityCurveData,
        existedGasHandlerEquipments,
        showGasHandlerEquipments,
    } = useAppSelector((state) => state?.gasCalculations);

    const {
        updateGasHandlerPumpID,
        updateGasHandlerPumpName,
        updateShowGkxGraphControl,
        updateGKXCalculationData,
        updateGKXDataHandler,
    } = useGasHandlerFacade();

    const {
        updateGasHandler,
        updateTypeOfShaft,
        updateUseGasHandler,
        updateExistedGasHandlerEquipments,
        loadEquipmentsGasHandler,
        updateGasCalculationOutput,
        updateShowHideGasHandlerEquipments,
    } = useGasCalculationFacade();

    const { updateGasHandlerCollapse } = useCollapseFacade();
    const { updateSchematicEquipmentData } = useCalculationFacade()

    useEffect(() => {
        updateShowGkxGraphControl(false);
    }, []);

    useEffect(() => {

    }, [GKXCalculationData])

    const handleToggleButton = (checked: boolean) => {
        updateShowGkxGraphControl(checked);
    };

    const handleChangeUseGasHandler = (option: any) => {
        updateUseGasHandler(option?.id);
        if (option?.id === '0') {
            updateTypeOfShaft(0);
            updateShowGkxGraphControl(false);
            updateGasHandler("");
            updateShowHideGasHandlerEquipments(false);
            updateExistedGasHandlerEquipments([]);
            updateSchematicEquipmentData();
            updateGKXDataHandler(null);
            const GasCalculationOutPut = {
                GKX_HPRating: 0
            };
            updateGasCalculationOutput(GasCalculationOutPut);
        }
    };

    const handleChangeGasHandler = async (option: any) => {
        const gasOutput = {
            GKX_FlowCorrection: BasicGasCalculation?.gkxFlowCorrection ?? 100,
            GKX_HeadCorrection: BasicGasCalculation?.gkxHeadCorrection ?? 100,
            GKX_PowerCorrection: BasicGasCalculation?.gkxPowerCorrection ?? 100
        }
        updateGKXCalculationData(option?.value);
        updateGasCalculationOutput(gasOutput);
        updateGasHandler(option?.value);
        updateGasHandlerPumpID(option?.value);
        updateGasHandlerPumpName(option?.label);
        loadEquipmentsGasHandler();
        updateExistedGasHandlerEquipments([]);
        if (option.value === "") {
            updateShowGkxGraphControl(false);
        }
        if (option?.label === "Select") {
            updateGasHandlerPumpName("");
            updateExistedGasHandlerEquipments([]);
            updateSchematicEquipmentData();
            updateGKXCalculationData(null);
            const GasCalculationOutPut = {
                GKX_HPRating: 0
            };
            updateGasCalculationOutput(GasCalculationOutPut);
            updateShowHideGasHandlerEquipments(false);
        }
    };

    const onSelectChangeTypeOfShaft = (option: any) => {
        updateTypeOfShaft(option?.value);
    };

    const handleOnClearEquipment = (id: string, index: number) => {
        const updatedEquipments = [...existedGasHandlerEquipments];
        if (index === 0) {
            updateExistedGasHandlerEquipments([{}]);
        } else {
            updatedEquipments.splice(index);
            if (
                updatedEquipments.length === 0 ||
                updatedEquipments[updatedEquipments.length - 1]?.id !== undefined
            ) {
                updatedEquipments.push({});
            }
            updateExistedGasHandlerEquipments(updatedEquipments);
        }
        updateSchematicEquipmentData();
    };

    const handleSelectEquipments = (option: any, index: number) => {
        const updatedArray = [...existedGasHandlerEquipments];
        updatedArray[index] = option;
        for (let i = updatedArray.length - 1; i > index; i--) {
            if (Object.keys(updatedArray[i]).length === 0) {
                updatedArray.splice(i, 1);
            }
        }
        const lastItem = updatedArray[updatedArray.length - 1];
        const equipmentLimit = Number(BasicGasCalculation?.EquipmentListForGasHandlers?.length || 0);
        const nonEmptyRows = updatedArray.filter(item => Object.keys(item).length > 0);
        if (
            nonEmptyRows.length < equipmentLimit &&
            (Object.keys(lastItem || {}).length !== 0)
        ) {
            updatedArray.push({});
        }

        updateExistedGasHandlerEquipments(updatedArray);
        updateSchematicEquipmentData();
    };


    const handleCollapseChange = (key: boolean) => {
        updateGasHandlerCollapse(key);
    };

    useEffect(() => {
        if (BasicGasCalculation?.EquipmentListForGasHandlers?.length === 2 && existedGasHandlerEquipments?.length === 1) {
            updateExistedGasHandlerEquipments([...existedGasHandlerEquipments, {}]);
        }
    }, [existedGasHandlerEquipments]);

    return (
        <Accordion
            title={LABELS?.gasHandler}
            link={'/help?tab=Gas-Calculations#wapperGasHandlers'}
            tooltipText={LABELS?.formula}
            isOpen={gasHandlerCollapse}
            onToggle={() => handleCollapseChange(!gasHandlerCollapse)}
            content={
                <div className="flex flex-col self-stretch gap-[16px] p-[16px] rounded-b-[8px]">
                    <Dropdown
                        label={LABELS?.useGasHandler}
                        options={[
                            { id: "1", name: LABELS?.yes },
                            { id: "0", name: LABELS?.no },
                        ]}
                        onSelect={(option) => handleChangeUseGasHandler(option)}
                        dropdownBgColor="bg-darkcolor-800"
                        bgColor="bg-transparent"
                        selected={BasicGasCalculation?.useOfChgPmp ?? "0"}
                        width="1/3"
                        height="80px"
                    />
                    {BasicGasCalculation?.useOfChgPmp === "1" && (
                        <>
                            <div className="grid sm:grid-cols-2 grid-cols-1 gap-[16px]">
                                <div className="flex w-full rounded-[8px] flex-col border-[1px] border-darkcolor-400">
                                    <div className="flex justify-between items-center px-[24px] py-[6.45px] border-b-[1px] border-b-darkcolor-400 w-full">
                                        <p className="text-white">{LABELS?.gasHandler}</p>
                                        <Select
                                            options={BasicGasCalculation?.chargePumpGKXList}
                                            onChange={handleChangeGasHandler}
                                            padding="px-[14px] py-[5px]"
                                            fontSize="16px"
                                            className="sm:px-0 px-[10px] w-[224px]"
                                            selectedValue={BasicGasCalculation?.chargePumpGKX !== "" ? BasicGasCalculation?.chargePumpGKX : ""}
                                            name={"chargePumpGKX"}
                                        />
                                    </div>
                                    <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                        <p className="text-white">{LABELS?.noOfStages}</p>
                                        <p className="text-white">
                                            {GKXCalculationData?.desiredStages}
                                        </p>
                                    </div>
                                    <div className="flex justify-between items-center px-[24px] py-[6.45px] border-b-[1px] border-b-darkcolor-400 w-full">
                                        <p className="text-white">{LABELS?.typeOfShaft}</p>
                                        <Select
                                            options={typeOfShaft}
                                            onChange={onSelectChangeTypeOfShaft}
                                            padding="px-[14px] py-[5px]"
                                            fontSize="16px"
                                            className="sm:px-0 px-[10px] w-[224px]"
                                            selectedValue={
                                                BasicGasCalculation?.hdn_GKX_ShaftType ?? 0
                                            }
                                            name={"hdn_GKX_ShaftType"}
                                        />
                                    </div>
                                    <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                        <p className="text-white">{LABELS?.targetFlowRate}</p>
                                        <p className="text-white">
                                            {GKXCalculationData?.targetFlowRate} {LABELS?.bpd}
                                        </p>
                                    </div>
                                    <div className="flex justify-between items-center px-[24px] py-[14px]">
                                        <p className="text-white">{LABELS?.liftStage}</p>
                                        <p className="text-white">
                                            {GKXCalculationData?.liftPerStage} {LABELS?.ft}
                                        </p>
                                    </div>
                                </div>
                                <div className="flex w-full rounded-[8px] flex-col border-[1px] border-darkcolor-400">
                                    <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                        <p className="text-white">{LABELS?.tdh}</p>
                                        <p className="text-white">
                                            {GKXCalculationData?.finalTDH} {LABELS?.ft}
                                        </p>
                                    </div>
                                    <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                        <p className="text-white">{LABELS?.totalbhpGas}</p>
                                        <p className="text-white">
                                            {GKXCalculationData?.totalPower} {LABELS?.hp}
                                        </p>
                                    </div>
                                    <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                        <p className="text-white">{LABELS?.bhpGasHandler}</p>
                                        <p className="text-white">
                                            {GasCalculationOutPut?.GKX_HPRating} {LABELS?.hp}
                                        </p>
                                    </div>
                                    <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                        <p className="text-white">{LABELS?.efficiency}</p>
                                        <p className="text-white">
                                            {GKXCalculationData?.efficiency ?? 0} %
                                        </p>
                                    </div>
                                    <div className="flex justify-between items-center px-[24px] py-[14px]">
                                        <p className="text-white">{LABELS?.shaftLoad}</p>
                                        <p className="text-white">
                                            {GKXCalculationData?.shaftLoad} %
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {showGasHandlerEquipments && (
                                <EquipmentTableAddChargePump
                                    options={
                                        BasicGasCalculation?.EquipmentListForGasHandlers?.length >
                                            0
                                            ? BasicGasCalculation?.EquipmentListForGasHandlers
                                            : []
                                    }
                                    onChange={handleSelectEquipments}
                                    equipments={existedGasHandlerEquipments?.length > 0
                                        ? existedGasHandlerEquipments
                                        : [{}]}
                                    onClear={(id: string, index: number) => handleOnClearEquipment(id, index)}
                                    rowLength={
                                        BasicGasCalculation?.EquipmentListForGasHandlers?.length >
                                            1
                                            ? 2
                                            : 1
                                    }
                                    equipmentGridParentContainer="SRGasHandlers"
                                    parentId={BasicGasCalculation?.chargePumpGKX}
                                />
                            )}
                            <div className="mb-[5px]">
                                <SwitchButton
                                    checked={showGkxGraphControl}
                                    onChange={handleToggleButton}
                                    label={LABELS?.showGasHandlerGraph}
                                    disabled={BasicGasCalculation?.chargePumpGKX === ""}
                                />
                            </div>
                            {BasicGasCalculation?.chargePumpGKX && showGkxGraphControl && (
                                <div className="mb-[15px] border-[1px] border-darkcolor-400 rounded-[8px] pt-[30px]">
                                    <PumpPerformanceChart data={gkxPumpCapacityCurveData} />
                                </div>
                            )}
                        </>
                    )}
                </div>
            }
        />
    );
};

export default GasHandler;
